import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Modal, Form } from "react-bootstrap";
import { ButtonComponent, AnchorComponent } from "../elements";
import axios from "axios";
import Select from "react-select";
import { encode } from "base-64";
import { API_URL, APP_PREFIX_PATH, getApiMessage } from "../../constant/constant";
import PaginationComponent from "../../components/PaginationComponent";
import { Row, Col } from "react-bootstrap";
import LabelFieldComponent from "../../components/fields/LabelFieldComponent";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import "./ClinicTable.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";

// Fallback country list when API fails or returns empty (same shape: country_id, country_name)
const DEFAULT_COUNTRIES = [
  { country_id: 1, country_name: "Kuwait" },
  { country_id: 2, country_name: "Saudi Arabia" },
  { country_id: 3, country_name: "United Arab Emirates" },
  { country_id: 4, country_name: "Bahrain" },
  { country_id: 5, country_name: "Oman" },
  { country_id: 6, country_name: "Qatar" },
  { country_id: 7, country_name: "Egypt" },
  { country_id: 8, country_name: "Jordan" },
  { country_id: 9, country_name: "Lebanon" },
  { country_id: 10, country_name: "Iraq" },
  { country_id: 11, country_name: "India" },
  { country_id: 12, country_name: "Pakistan" },
  { country_id: 13, country_name: "United Kingdom" },
  { country_id: 14, country_name: "United States" },
  { country_id: 15, country_name: "Canada" },
  { country_id: 16, country_name: "Australia" },
  { country_id: 17, country_name: "France" },
  { country_id: 18, country_name: "Germany" },
  { country_id: 19, country_name: "Philippines" },
  { country_id: 20, country_name: "Other" },
];

export default function ClinicTableComponent({ thead, tbody }) {
  const { t, currentLanguage } = useContext(TranslatorContext);
  const langCode = currentLanguage?.code || "en";
  const [clinicDetails, setClinicDetails] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  // const [selectedLoction, setselectedLoction] = useState([]);
  const [clinicId, setClinicId] = useState("");

  const [services, setservices] = useState([]);
  const [countries, setCountries] = useState(DEFAULT_COUNTRIES);
  const [location, setlocation] = useState([]);
  const [Error, setError] = useState("");
  const [ErrorEmail, setErrorEmail] = useState("");
  const [LocError, setlocError] = useState("");

  const [userData, setUserData] = useState("");
  const [editModal, setEditModal] = useState(false);
  const [AddModal, setAddModal] = useState(false);
  const [alertModal, setAlertModal] = useState(false);
  const [deleteModel, setdeleteModel] = useState(false);
  const [deleteModel1, setdeleteModel1] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [ActiveClinic, setActiveClinic] = useState("");
  const [editclinicId, seteditClinicId] = useState("");
  const [editclinicName, seteditClinicName] = useState("");
  const [editclinicNameArabic, seteditClinicNameArabic] = useState("");
  // const [editservice, seteditservice] = useState('');
  const [editclinicCity, seteditClinicCity] = useState("");
  const [editclinicMobile, seteditclinicMobile] = useState("");
  const [editimage, seteditimage] = useState("");
  const [editimages, seteditimages] = useState("");
  const [editabout, seteditabout] = useState("");
  const [editaboutArabic, seteditaboutArabic] = useState("");
  const [editcommission, seteditcommission] = useState("");

  const [editclinicNameerror, seteditClinicNameerror] = useState("");
  const [editclinicNameArabicError, seteditClinicNameArabicError] =
    useState("");
  const [editclinicCityerror, seteditClinicCityerror] = useState("");
  const [editabouterror, seteditabouterror] = useState("");
  const [editserviceError, seteditserviceError] = useState("");
  const [editclinicMobileerror, seteditclinicMobileerror] = useState("");
  const [editcommissionError, seteditcommissionError] = useState("");

  const [AddClinicName, setaddClinicName] = useState("");
  const [AddClinicNameArabic, setAddClinicNameArabic] = useState("");
  const [AddClinicCity, setAddClinicCity] = useState("");
  const [AddMultipleImg, setAddMultipleImg] = useState([]);
  const [AddImage, setAddImage] = useState("");
  const [AddLatitude, setAddLatitude] = useState("");
  const [AddLongitude, setAddLongitude] = useState("");
  const [AddAbout, setAddAbout] = useState("");
  const [AddAboutArabic, setAddAboutArabic] = useState("");
  const [AddEmail, setAddEmail] = useState("");
  const [AddMobile, setAddMobile] = useState("");
  const [AddPassword, setAddPassword] = useState("");
  const [AddCommission, setAddCommission] = useState("");

  const [AddClinicNameError, setaddClinicNameError] = useState("");
  const [AddClinicNameArabicError, setAddClinicNameArabicError] = useState("");
  const [AddClinicCityError, setAddClinicCityError] = useState("");
  const [AddClinicServiceError, setAddClinicServiceError] = useState("");
  const [AddImageError, setAddImageError] = useState("");
  const [AddLatitudeError, setAddLatitudeError] = useState("");
  const [AddLongitudeError, setAddLongitudeError] = useState("");
  const [AddAboutError, setAddAboutError] = useState("");
  const [AddMultipleImgError, setAddMultipleImgError] = useState("");
  const [AddEmailError, setAddEmailError] = useState("");
  const [AddMobileError, setAddMobileError] = useState("");
  const [AddPasswordError, setAddPasswordError] = useState("");
  const [AddCommissionError, setAddCommissionError] = useState("");
  const [addlocationError, setaddlocationError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [confirmpassword, setconfirmpassword] = useState("");
  const [confirmpasswordError, setconfirmpasswordError] = useState("");
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [helperText, setHelperText] = useState("");
  const [Address, setAddress] = useState("");
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();

  const [status, setstatus] = useState("");
  const [flag, setflag] = useState("");
  const [toggleLoading, setToggleLoading] = useState(false);
  const [saveEditLoading, setSaveEditLoading] = useState(false);
  const [addClinicLoading, setAddClinicLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const entriesPerPage = 5;

  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;

  const filteredUsers = clinicDetails.filter((user) => {
    const lowercasedTerm = searchTerm.toLowerCase();
    return (
      user.clinic_name?.toLowerCase().includes(lowercasedTerm) ||
      user.clinic_city?.toLowerCase().includes(lowercasedTerm) ||
      user.createtime?.toLowerCase().includes(lowercasedTerm)
    );
  });

  const currentUsers = filteredUsers.slice(indexOfFirstEntry, indexOfLastEntry);

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  const fetchClinicDetails = () => {
    const user_type = localStorage.getItem("user_type");

    axios
      .post(API_URL + "/get_our_clinics", { user_type })
      .then((response) => {
        console.log(response.data.clinic_arr.reverse(), "clinic_details");
        setClinicDetails(response.data.clinic_arr.reverse() || []);
        // console.log(response.data.clinic_arr.reverse() || []);
      })
      .catch((error) => {
        console.error("Error fetching user details:", error);
      });
  };

  const getServices = () => {
    const user_type = localStorage.getItem("user_type");
    axios
      .post(API_URL + "/fetch_services", { user_type })
      .then((res) => {
        const formattedServices = res.data.service_arr.map((service) => ({
          label: service.service_name,
          value: service.service_id,
        }));
        setservices(formattedServices);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getCountry = () => {
    axios
      .get(API_URL + "/fetch_country_list")
      .then((res) => {
        const list =
          res.data?.country_arr || res.data?.country_list || res.data;
        const arr =
          Array.isArray(list) && list.length > 0 ? list : DEFAULT_COUNTRIES;
        setCountries(arr);
      })
      .catch((error) => {
        console.error("fetch_country_list failed", error);
        setCountries(DEFAULT_COUNTRIES);
      });
  };

  useEffect(() => {
    fetchClinicDetails();
    getServices();
    getCountry();
  }, []);

  const handleUserAction = (
    action,
    clinic_id,
    clinic_name,
    clinic_city,
    about_clinic,
    active_flag,
    mobile,
    item,
    downpayment_percentage
  ) => {
    if (action === "active") {
      setActiveClinic(clinic_id);
      setstatus("activate");
      setflag(active_flag);
      setAlertModal(true);
    } else if (action === "deactive") {
      setActiveClinic(clinic_id);
      setstatus("deactivate");
      setflag(active_flag);
      setAlertModal(true);
    } else if (action === "edit") {
      seteditClinicId(clinic_id);
      seteditClinicName(clinic_name);
      seteditClinicNameArabic((item && item.clinic_name_arabic) || "");
      seteditClinicCity(clinic_city);
      seteditabout(about_clinic);
      seteditaboutArabic((item && item.about_clinic_arabic) || "");
      seteditclinicMobile(mobile || "");
      seteditcommission(downpayment_percentage);
      const serviceArr = (item && item.service_arr) || item || [];
      const formattedServices = Array.isArray(serviceArr)
        ? serviceArr.map((service) => ({
            label: service.service_name,
            value: service.service_id,
          }))
        : [];
      setSelectedServices(formattedServices);
    } else if (action == "delete") {
      setdeleteModel(true);
      setClinicId(clinic_id);
    }
  };

  const ClinicActiveDeactive = () => {
    setToggleLoading(true);
    setError("");
    axios
      .post(API_URL + "/activate_deactivate_clinic", {
        clinic_id: ActiveClinic,
        flag: flag,
      })
      .then((res) => {
        if (res.data.success) {
          const newFlag = flag === 1 ? 0 : 1;
          setClinicDetails((prev) =>
            prev.map((c) =>
              c.clinic_id === ActiveClinic ? { ...c, active_flag: newFlag } : c
            )
          );
          setAlertModal(false);
        } else {
          setError(getApiMessage(res.data, langCode) || t("something_went_wrong"));
        }
      })
      .catch((error) => {
        setError(getApiMessage(error.response?.data, langCode) || error.message || t("something_went_wrong"));
        console.error(error);
      })
      .finally(() => setToggleLoading(false));
  };

  const handleSaveChanges = () => {
    let hasError = false;
    if (!editclinicName || editclinicName.trim() == "") {
      seteditClinicNameerror(t("enter_clinic_name"));
      hasError = true;
    }
    if (!editclinicCity || editclinicCity.trim() == "") {
      seteditClinicCityerror(t("enter_clinic_city"));
      hasError = true;
    }
    if (!editcommission) {
      seteditcommissionError(t("enter_commission"));
      hasError = true;
    }
    // if (!selectedServices) {
    //     seteditserviceError(t("enter_service_name"));
    //     hasError = true;
    // }
    // if (!editabout || editabout.trim() == '') {
    //     seteditabouterror(t("enter_about_me"));
    //     hasError = true;
    // }
    if (!editclinicMobile) {
      seteditclinicMobileerror(t("enter_mobile"));
      hasError = true;
    }
    if (hasError) {
      return;
    }
    // var services = JSON.stringify(selectedServices.map(user => user.value));

    const formData = new FormData();
    formData.append("clinic_id", editclinicId);
    formData.append("clinic_name", editclinicName);
    formData.append("clinic_name_arabic", editclinicNameArabic || "");
    // formData.append('service_id', services);
    formData.append("clinic_city", editclinicCity);
    formData.append("downpayment_percentage", editcommission);
    formData.append("about_clinic", editabout || "");
    formData.append("about_clinic_arabic", editaboutArabic || "");
    formData.append("mobile", editclinicMobile);
    if (editimage) {
      formData.append("image", editimage);
    }
    // AddMultipleImg.forEach((file, index) => {
    //     formData.append('images', file);
    // });

    setSaveEditLoading(true);
    setError("");
    setErrorEmail("");
    axios
      .post(API_URL + "/edit_clinic", formData)
      .then((response) => {
        if (!response.data.success) {
          const msg = getApiMessage(response.data, langCode);
          if (response.data.key === "emailExist") setErrorEmail(msg || t("emailMobileAlready"));
          else setError(msg || t("clinic_already_exist"));
          return;
        }
        setEditModal(false);
        setAddMultipleImg("");
        fetchClinicDetails();
      })
      .catch((error) => {
        setError(getApiMessage(error.response?.data, langCode) || error.message || t("something_went_wrong"));
        console.error("Error updating clinic:", error);
      })
      .finally(() => setSaveEditLoading(false));
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  // add clinic
  const handleAddclinic = () => {
    let hasError = false;
    if (!AddClinicName || AddClinicName.trim() == "") {
      setaddClinicNameError(t("enter_clinic_name"));
      hasError = true;
    }
    if (!AddClinicCity || AddClinicCity.trim() == "") {
      setAddClinicCityError(t("enter_clinic_city"));
      hasError = true;
    }
    // if (!selectedServices || selectedServices == null || selectedServices == " ") {
    //     setAddClinicServiceError(t("enter_service_name"));
    //     hasError = true;
    // }
    // if (!AddLatitude || AddLatitude.trim() == '') {
    //     setAddLatitudeError('Please enter latitude');
    //     hasError = true;
    // }
    // if (!AddLongitude || AddLongitude.trim() == '') {
    //     setAddLongitudeError('Please enter longitude');
    //     hasError = true;
    // }
    // if (!AddAbout || AddAbout.trim() == '') {
    //     setAddAboutError(t("enter_about_me"));
    //     hasError = true;
    // }
    if (!AddImage) {
      setAddImageError(t("upload_image"));
      hasError = true;
    }
    if (!AddEmail) {
      setAddEmailError(t("enter_your_email"));
      hasError = true;
    }
    if (!AddCommission) {
      setAddCommissionError(t("enter_commission"));
      hasError = true;
    }
    if (!AddMobile) {
      setAddMobileError(t("enter_mobile"));
      hasError = true;
    }
    if (!AddPassword) {
      setAddPasswordError(t("enter_password"));
      hasError = true;
    }
    if (!confirmpassword) {
      setconfirmpasswordError(t("enter_confirm_password"));
      hasError = true;
    }

    if (AddPassword != confirmpassword) {
      setconfirmpasswordError(t("new_confirm_match"));
      hasError = true;
    }
    if (!Address || Address == null || Address == " ") {
      setaddlocationError(t("select_location"));
      hasError = true;
    }
    if (!latitude && !longitude) {
      setlocError(t("select_location"));
      hasError = true;
    }

    if (hasError) {
      return;
    }
    // var services = JSON.stringify(selectedServices.map(user => user.value));

    // const data = {
    //     clinic_name: AddClinicName,
    //     clinic_city: AddClinicCity,
    //     service_id: services,
    //     latitude: AddLatitude,
    //     longitude: AddLongitude,
    //     about_clinic: AddAbout,
    //     image: AddImage,
    //     AddMultipleImg: AddMultipleImg
    // }
    console.log(latitude, longitude);

    const formData = new FormData();
    formData.append("clinic_name", AddClinicName);
    formData.append("clinic_name_arabic", AddClinicNameArabic || "");
    formData.append("clinic_city", AddClinicCity);
    formData.append("downpayment_percentage", AddCommission);
    // formData.append('service_id', services);
    formData.append("email", AddEmail);
    formData.append("mobile", AddMobile);
    formData.append("password", AddPassword);
    formData.append("address", Address);
    formData.append("latitude", latitude);
    formData.append("longitude", longitude);

    formData.append("about_clinic", AddAbout || "");
    formData.append("about_clinic_arabic", AddAboutArabic || "");
    formData.append("image", AddImage);

    // AddMultipleImg.forEach((file, index) => {
    //     formData.append('images', file);
    // });

    console.log("data", formData);

    setAddClinicLoading(true);
    setError("");
    setErrorEmail("");
    axios
      .post(API_URL + "/add_clinic", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (!response.data.success) {
          const msg = getApiMessage(response.data, langCode);
          if (response.data.key === "emailExist") setErrorEmail(msg || t("emailMobileAlready"));
          else setError(msg || t("clinic_already_exist"));
          return;
        }
        setAddModal(false);
        fetchClinicDetails();
      })
      .catch((error) => {
        setError(getApiMessage(error.response?.data, langCode) || error.message || t("something_went_wrong"));
        console.error("Error adding clinic:", error);
      })
      .finally(() => setAddClinicLoading(false));
  };

  const deleteClinic = () => {
    if (clinicId) {
      setDeleteLoading(true);
      setError("");
      axios
        .post(API_URL + "/delete_clinics", { clinic_id: clinicId })
        .then((res) => {
          if (!res.data.success) {
            setError(getApiMessage(res.data, langCode) || t("something_went_wrong"));
            return;
          }
          setdeleteModel(false);
          setdeleteModel1(true);
          setTimeout(() => setdeleteModel1(false), 2000);
          fetchClinicDetails();
        })
        .catch((error) => {
          setError(getApiMessage(error.response?.data, langCode) || error.message || t("something_went_wrong"));
          console.error(error);
        })
        .finally(() => setDeleteLoading(false));
    }
  };

  const handleChange = async (value) => {
    setSelectedPlace(value);
    setAddress(value.label);
    if (value) {
      try {
        const geocoder = new window.google.maps.Geocoder();
        const response = await geocoder.geocode({
          placeId: value.value.place_id,
        });
        if (response.results[0]) {
          const { lat, lng } = response.results[0].geometry.location;
          const latitude = lat();
          const longitude = lng();
          console.log("Latitude:", latitude, "Longitude:", longitude);
          // You can pass these to a parent component or handle them as needed
          setLatitude(latitude);
          setLongitude(longitude);
        }
      } catch (err) {
        console.error("Error fetching place details:", err);
        setlocError("Failed to fetch location details.");
        setHelperText("");
      }

      setlocError("");
      setHelperText("");
    } else {
      setlocError("Please select a location.");
      setHelperText("");
    }
  };

  console.log(countries);

  return (
    <>
      <Row
        xs={1}
        sm={2}
        xl={4}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Col>
          <LabelFieldComponent
            type="search"
            // label={t('search_by')}
            icon="Search"
            placeholder={`${t("search_here")}`}
            labelDir="label-col"
            fieldSize="mb-4 w-100 h-md"
            value={searchTerm}
            onChange={handleSearch}
          />
        </Col>
        <Col style={{ textAlign: "right", marginBottom: "5px" }}>
          <button
            style={{
              background: "#2b77e5",
              padding: "7px 13px",
              color: "#fff",
              borderRadius: "5px",
            }}
            onClick={() => {
              setAddModal(true);
              setaddClinicName("");
              setAddClinicNameArabic("");
              setaddClinicNameError("");
              setAddClinicNameArabicError("");
              setAddClinicCity("");
              setAddClinicCityError("");
              setSelectedServices("");
              setAddClinicServiceError("");
              setAddImage("");
              setAddImageError("");
              setAddLatitude("");
              setAddLatitudeError("");
              setAddLongitude("");
              setAddLongitudeError("");
              setAddAbout("");
              setAddAboutArabic("");
              setAddAboutError("");
              setAddMultipleImgError("");
              setError("");
              setAddEmail("");
              setAddMobile("");
              setAddPassword("");
              setAddEmailError("");
              setAddMobileError("");
              setAddPasswordError("");
              setconfirmpasswordError("");
            }}
          >
            {" "}
            <AddIcon className="me-2" /> {t("add_clinic")}{" "}
          </button>
        </Col>
      </Row>

      <div className="mc-table-responsive">
        <table className="mc-table">
          <thead className="mc-table-head primary">
            <tr>
              <th>
                <div className="mc-table-check">
                  <p>{t("sno")}</p>
                </div>
              </th>
              <th>{t("actions")}</th>
              <th>{t("image")}</th>
              <th>{t("clinic_name")}</th>
              <th>{t("clinic_name_arabic")}</th>
              <th>{t("clinic_city")}</th>
              <th>{t("status")}</th>
              <th>{t("createtime")}</th>
            </tr>
          </thead>
          <tbody className="mc-table-body even">
            {currentUsers?.map((item, index) => (
              <tr key={index}>
                <td title="id">
                  <div className="mc-table-check">
                    <p>{indexOfFirstEntry + index + 1}</p>
                  </div>
                </td>
                <td>
                  <div className="mc-table-action">
                    <AnchorComponent
                      to={`${APP_PREFIX_PATH}/clinic-view/${encode(
                        item.clinic_id
                      )}`}
                      title="View"
                      className="material-icons view"
                    >
                      visibility
                    </AnchorComponent>
                    <ButtonComponent
                      title="Edit"
                      className="material-icons edit"
                      onClick={() => {
                        setEditModal(true, setUserData(item));
                        handleUserAction(
                          "edit",
                          item.clinic_id,
                          item.clinic_name,
                          item.clinic_city,
                          item.about_clinic,
                          item.active_flag,
                          item.mobile,
                          item,
                          item.downpayment_percentage
                        );
                      }}
                    >
                      edit
                    </ButtonComponent>

                    {/* <ButtonComponent type="button" className="material-icons delete" onClick={() => handleUserAction('delete', item.clinic_id)}>delete</ButtonComponent> */}

                    {item.active_flag === 0 ? (
                      <AnchorComponent
                        title="inactive"
                        className="material-icons inactive"
                        style={{
                          background: "rgb(255 223 223)",
                          color: "red",
                          lineHeight: "15px",
                        }}
                        onClick={() => {
                          setAlertModal(true);
                          handleUserAction(
                            "active",
                            item.clinic_id,
                            item.clinic_name,
                            item.clinic_city,
                            item.about_clinic,
                            item.active_flag
                          );
                        }}
                      >
                        <ToggleOffIcon />
                      </AnchorComponent>
                    ) : (
                      <AnchorComponent
                        title="active"
                        className="material-icons active"
                        style={{
                          background: "#d4ffd4",
                          color: "green",
                          lineHeight: "15px",
                        }}
                        onClick={() => {
                          setAlertModal(true);
                          handleUserAction(
                            "deactive",
                            item.clinic_id,
                            item.clinic_name,
                            item.clinic_city,
                            item.about_clinic,
                            item.active_flag
                          );
                        }}
                      >
                        <ToggleOnIcon />
                      </AnchorComponent>
                    )}

                    {/* <ButtonComponent title="Block" className="material-icons block" onClick={() => handleUserAction('block', item.user_id, item.active_flag)}>block</ButtonComponent> */}
                  </div>
                </td>
                <td
                  title={
                    item.clinic_name_arabic ||
                    item.clinic_name_ar ||
                    item.clinic_name
                  }
                >
                  <div className="mc-table-profile">
                    <img
                      src={
                        item.image
                          ? `${item.image}`
                          : `hospital-placeholder.webp`
                      }
                      alt="Profile"
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </td>
                <td>
                  <span>{item.clinic_name || "NA"}</span>
                </td>
                <td style={{ direction: "rtl", textAlign: "right" }}>
                  <span>
                    {item.clinic_name_arabic || item.clinic_name_ar || "—"}
                  </span>
                </td>
                <td>{item.clinic_city || "NA"}</td>
                <td>
                  <p
                    style={{
                      margin: "auto",
                      width: "80px",
                      textAlign: "center",
                    }}
                    className={
                      item.active_flag === 0
                        ? "mc-table-badge red"
                        : "mc-table-badge green"
                    }
                  >
                    {item.active_flag === 0 ? "Deactive" : "Active"}
                  </p>
                </td>
                <td>{item.createtime || "NA"}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <PaginationComponent
          totalEntries={filteredUsers.length}
          entriesPerPage={entriesPerPage}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />

        <Modal
          show={editModal}
          onHide={() => setEditModal(false)}
          backdrop="static"
        >
          <div className="mc-user-modal">
            <img
              src={
                userData.image
                  ? `${userData.image}`
                  : `placeholder.webp`
              }
              alt="Profile"
            />
            <h4>{userData?.name}</h4>
            <p>{userData?.email}</p>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("clinic_name")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("enter_clinic_name")}
                value={editclinicName}
                onChange={(e) => {
                  seteditClinicName(e.target.value);
                  seteditClinicNameerror("");
                  setError("");
                }}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {editclinicNameerror}
              </p>
            </Form.Group>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("clinic_name_arabic")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("placeholder_enter_clinic_arabic")}
                value={editclinicNameArabic}
                onChange={(e) => {
                  seteditClinicNameArabic(e.target.value);
                  seteditClinicNameArabicError("");
                }}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {editclinicNameArabicError}
              </p>
            </Form.Group>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("country")}</Form.Label>
              <Form.Select
                //type="text"
                placeholder={t("enter_clinic_city")}
                value={editclinicCity}
                onChange={(e) => {
                  seteditClinicCity(e.target.value);
                  seteditClinicCityerror("");
                }}
              >
                <option value="">{t("select_country")}</option>
                {countries?.map((country) => (
                  <option key={country.country_id} value={country.country_name}>
                    {country.country_name}
                  </option>
                ))}
              </Form.Select>
              <p style={{ color: "red", textAlign: "left" }}>
                {editclinicCityerror}
              </p>
            </Form.Group>

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("commission")} %</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("enter_commission")}
                value={editcommission}
                onChange={(e) => {
                  seteditcommission(e.target.value);
                  seteditcommissionError("");
                }}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {editcommissionError}
              </p>
            </Form.Group>

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("mobile")}</Form.Label>
              <PhoneInput
                country="kw"
                preferredCountries={["kw"]}
                value={editclinicMobile}
                onChange={(value) => {
                  seteditclinicMobile(value);
                  seteditclinicMobileerror("");
                }}
                inputStyle={{
                  width: "100%",
                  paddingLeft: "48px",
                  borderRadius: "4px",
                  border: editclinicMobileerror
                    ? "1px solid #dc3545"
                    : "1px solid #ced4da",
                }}
                placeholder={t("enter_mobile")}
                countryCodeEditable={false}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {editclinicMobileerror}
              </p>
            </Form.Group>

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("image")}</Form.Label>
              <Form.Control
                type="file"
                onChange={(e) => {
                  const file = e.target.files[0];
                  seteditimage(file);
                }}
              />
            </Form.Group>
            <p style={{ color: "red", textAlign: "left" }}>{Error}</p>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("about_me")}</Form.Label>
              <Form.Control
                as="textarea"
                placeholder={t("enter_about_me")}
                value={editabout}
                onChange={(e) => {
                  seteditabout(e.target.value);
                  seteditabouterror("");
                }}
              />
              <p style={{ color: "red" }}>{editabouterror}</p>
            </Form.Group>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("about_me_arabic")}</Form.Label>
              <Form.Control
                as="textarea"
                placeholder={t("placeholder_enter_about_arabic")}
                value={editaboutArabic}
                onChange={(e) => {
                  seteditaboutArabic(e.target.value);
                }}
              />
            </Form.Group>

            {/* <Form.Group className="form-group mb-4">
                            <Form.Label>{t('cover_image')}</Form.Label>
                            <Form.Control
                                type="file"
                                multiple
                                onChange={(e) => {
                                    const files = Array.from(e.target.files);
                                    setAddMultipleImg((prev) => [...prev, ...files]);
                                    setAddMultipleImgError('');
                                }}
                            />
                            <p style={{ color: 'red' }}>{AddMultipleImgError}</p>
                        </Form.Group> */}

            {/* Display selected images */}
            {AddMultipleImg.length > 0 && (
              <div className="selected-images">
                <h5>Selected Images:</h5>
                <div className="row">
                  {AddMultipleImg.map((file, index) => (
                    <div className="col-lg-3" key={index}>
                      <img
                        src={URL.createObjectURL(file)}
                        alt={file.name}
                        style={{
                          width: "100px",
                          height: "100px",
                          margin: "5px",
                          objectFit: "cover",
                        }} //
                      />
                      {/* {file.name} */}
                    </div>
                  ))}
                </div>
              </div>
            )}

            <Modal.Footer>
              <ButtonComponent
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  setEditModal(false);
                  setAddMultipleImg("");
                  setError("");
                }}
              >
                {t("close_popup")}
              </ButtonComponent>
              <ButtonComponent
                type="button"
                className="btn btn-success"
                onClick={handleSaveChanges}
                disabled={saveEditLoading}
              >
                {saveEditLoading
                  ? t("loading") || "Loading..."
                  : t("save_changes")}
              </ButtonComponent>
            </Modal.Footer>
          </div>
        </Modal>

        <Modal
          show={AddModal}
          onHide={() => setAddModal(false)}
          backdrop="static"
        >
          <div className="mc-user-modal">
            <img
              src={`hospital-placeholder.webp`}
              alt="Profile"
            />
            <h4>{userData?.name}</h4>
            <p>{userData?.email}</p>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("clinic_name")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("enter_clinic_name")}
                value={AddClinicName}
                onChange={(e) => {
                  setaddClinicName(e.target.value);
                  setaddClinicNameError("");
                }}
                maxLength={30}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {AddClinicNameError}
              </p>
            </Form.Group>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("clinic_name_arabic")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("placeholder_enter_clinic_arabic")}
                value={AddClinicNameArabic}
                onChange={(e) => {
                  setAddClinicNameArabic(e.target.value);
                  setAddClinicNameArabicError("");
                }}
                maxLength={30}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {AddClinicNameArabicError}
              </p>
            </Form.Group>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("email")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("enter_email")}
                value={AddEmail}
                onChange={(e) => {
                  setAddEmail(e.target.value);
                  setAddEmailError("");
                  setErrorEmail("");
                }}
                maxLength={100}
              />
              <p style={{ color: "red", textAlign: "left" }}>{AddEmailError}</p>
            </Form.Group>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("mobile")}</Form.Label>
              <PhoneInput
                country="kw"
                preferredCountries={["kw"]}
                value={AddMobile}
                onChange={(value) => {
                  if (value.length <= 25) {
                    setAddMobile(value);
                  }
                  setAddMobileError("");
                  setErrorEmail("");
                }}
                inputStyle={{
                  width: "100%",
                  paddingLeft: "46px",

                  borderRadius: "4px",
                  borderColor: AddMobileError ? "red" : "#ced4da",
                }}
                placeholder={t("enter_mobile")}
                countryCodeEditable={false}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {AddMobileError}
              </p>
            </Form.Group>

            {/* <Form.Group className="form-group mb-4 ml-2">
                            <Form.Label>{t('password')}</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder={t('enter_password')}
                                value={AddPassword}
                                onChange={(e) => { setAddPassword(e.target.value); setAddPasswordError('') }}
                                maxLength={16}
                            />
                            <p style={{ color: 'red', textAlign: "left" }}>{AddPasswordError}</p>
                        </Form.Group> */}
            {/* sdkfj */}
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("password")}</Form.Label>
              <div className="input-group">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder={t("enter_password")}
                  value={AddPassword}
                  onChange={(e) => {
                    setAddPassword(e.target.value);
                    setAddPasswordError("");
                  }}
                />
                <span
                  className="input-group-text"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ cursor: "pointer" }}
                >
                  {showPassword ? <FaEye /> : <FaEyeSlash />}
                </span>
              </div>
              <p style={{ color: "red", textAlign: "left" }}>
                {AddPasswordError}
              </p>
            </Form.Group>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("confirm_password")}</Form.Label>
              <div className="input-group">
                <Form.Control
                  type={showPassword1 ? "text" : "password"}
                  placeholder={t("enter_confirm_password")}
                  value={confirmpassword}
                  onChange={(e) => {
                    setconfirmpassword(e.target.value);
                    setconfirmpasswordError("");
                  }}
                />
                <span
                  className="input-group-text"
                  onClick={() => setShowPassword1(!showPassword1)}
                  style={{ cursor: "pointer" }}
                >
                  {showPassword1 ? <FaEye /> : <FaEyeSlash />}
                </span>
              </div>
              <p style={{ color: "red", textAlign: "left" }}>
                {confirmpasswordError}
              </p>
            </Form.Group>

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("country")}</Form.Label>
              <Form.Select
                //type=""
                placeholder={t("enter_clinic_city")}
                value={AddClinicCity}
                onChange={(e) => {
                  setAddClinicCity(e.target.value);
                  setAddClinicCityError("");
                }}
              >
                <option value="">{t("select_country")}</option>
                {countries?.map((country) => (
                  <option key={country.country_id} value={country.country_name}>
                    {country.country_name}
                  </option>
                ))}
              </Form.Select>
              <p style={{ color: "red", textAlign: "left" }}>
                {AddClinicCityError}
              </p>
            </Form.Group>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("commission")} %</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("enter_commission")}
                value={AddCommission}
                onChange={(e) => {
                  setAddCommission(e.target.value);
                  setAddCommissionError("");
                }}
                maxLength={2}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {AddCommissionError}
              </p>
            </Form.Group>

            {/* 
                      <Form.Group className="form-group mb-4 ml-2">
                            <Form.Label>{t('clinic_service')}</Form.Label>

                            <Select
                                isMulti
                                options={services}
                                value={selectedServices}
                                onChange={(e) => {
                                    setSelectedServices(e);
                                    setAddClinicServiceError('');
                                }}
                                placeholder={t("enter_service_name")}
                            />
                            <p style={{ color: 'red', textAlign: "left" }}>{AddClinicServiceError}</p>
                        </Form.Group>
 */}

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("image")}</Form.Label>
              <Form.Control
                type="file"
                onChange={(e) => {
                  const file = e.target.files[0];
                  setAddImage(file);
                  setAddImageError("");
                }}
              />
              <p style={{ color: "red", textAlign: "left" }}>{AddImageError}</p>
            </Form.Group>

            {/* <Form.Group className="form-group mb-4 ml-2">
                            <Form.Label>{t('latitude')}</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder={t('enter_latitude')}
                                value={AddLatitude}
                                onChange={(e) => { setAddLatitude(e.target.value); setAddLatitudeError('') }}
                            />
                            <p style={{ color: 'red' }}>{AddLatitudeError}</p>
                        </Form.Group>
                        <Form.Group className="form-group mb-4 ml-2">
                            <Form.Label>{t('longitude')}</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder={t('enter_longitude')}
                                value={AddLongitude}
                                onChange={(e) => { setAddLongitude(e.target.value); setAddLongitudeError('') }}
                            />
                            <p style={{ color: 'red' }}>{AddLongitudeError}</p>
                        </Form.Group> */}

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("location")}</Form.Label>

              {/* <Select
                                isMulti
                                options={location}
                                value={selectedLoction}
                                onChange={(e) => {
                                    setselectedLoction(e);

                                }}
                                placeholder={t("select_location")}
                            /> */}
              <GooglePlacesAutocomplete
                apiKey="AIzaSyBDrvmlngLxqDR_biZIxnCRT1ssvghv0mM"
                selectProps={{
                  onChange: handleChange,
                  placeholder: "Search Location",
                  noOptionsMessage: () => null,
                  loadingMessage: () => null,
                }}
              />
              <p style={{ color: "red", textAlign: "left" }}>{LocError}</p>
            </Form.Group>

            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("about_me")}</Form.Label>
              <Form.Control
                as="textarea"
                placeholder={t("enter_about_me")}
                value={AddAbout}
                onChange={(e) => {
                  setAddAbout(e.target.value);
                  setAddAboutError("");
                }}
              />
              <p style={{ color: "red" }}>{AddAboutError}</p>
            </Form.Group>
            <Form.Group className="form-group mb-4 ml-2">
              <Form.Label>{t("about_me_arabic")}</Form.Label>
              <Form.Control
                as="textarea"
                placeholder={t("placeholder_enter_about_arabic")}
                value={AddAboutArabic}
                onChange={(e) => {
                  setAddAboutArabic(e.target.value);
                }}
              />
            </Form.Group>

            {/* <Form.Group className="form-group mb-4">
                            <Form.Label>{t('cover_image')}</Form.Label>
                            <Form.Control
                                type="file"
                                multiple
                                onChange={(e) => {
                                    const files = Array.from(e.target.files);
                                    setAddMultipleImg((prev) => [...prev, ...files]);
                                    setAddMultipleImgError('');
                                }}
                            />
                            <p style={{ color: 'red' }}>{AddMultipleImgError}</p>
                        </Form.Group> */}

            {/* Display selected images */}
            {AddMultipleImg.length > 0 && (
              <div className="selected-images">
                <h5>Selected Images:</h5>
                <div className="row">
                  {AddMultipleImg.map((file, index) => (
                    <div className="col-lg-3" key={index}>
                      <img
                        src={URL.createObjectURL(file)}
                        alt={file.name}
                        style={{
                          width: "100px",
                          height: "100px",
                          margin: "5px",
                          objectFit: "cover",
                        }} //
                      />
                      {/* {file.name} */}
                    </div>
                  ))}
                </div>
              </div>
            )}
            <p style={{ color: "red", textAlign: "left" }}>{Error}</p>
            <p style={{ color: "red", textAlign: "left" }}>{ErrorEmail}</p>

            <Modal.Footer>
              <ButtonComponent
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  setAddModal(false);
                  setaddClinicName("");
                  setAddClinicNameArabic("");
                  setaddClinicNameError("");
                  setAddClinicNameArabicError("");
                  setAddClinicCity("");
                  setAddClinicCityError("");
                  setSelectedServices("");
                  setAddClinicServiceError("");
                  setAddImage("");
                  setAddImageError("");
                  setAddLatitude("");
                  setAddLatitudeError("");
                  setAddLongitude("");
                  setAddLongitudeError("");
                  setAddAbout("");
                  setAddAboutArabic("");
                  setAddAboutError("");
                  setAddMultipleImg("");
                  setAddMultipleImgError("");
                  setError("");
                  setAddEmail("");
                  setAddMobile("");
                  setAddPassword("");
                  setAddEmailError("");
                  setAddMobileError("");
                  setAddPasswordError("");
                  setAddCommissionError();
                  setconfirmpasswordError("");
                  setErrorEmail("");
                }}
              >
                {t("close_popup")}
              </ButtonComponent>
              <ButtonComponent
                type="button"
                className="btn btn-success"
                onClick={handleAddclinic}
                disabled={addClinicLoading}
              >
                {addClinicLoading
                  ? t("loading") || "Loading..."
                  : t("save_changes")}
              </ButtonComponent>
            </Modal.Footer>
          </div>
        </Modal>

        <Modal
          show={alertModal}
          onHide={() => !toggleLoading && setAlertModal(false)}
        >
          <div className="mc-alert-modal">
            <i className="material-icons">new_releases</i>
            <h3>Are you sure!</h3>
            <p>Want to {status} this clinic?</p>
            <Modal.Footer>
              <ButtonComponent
                type="button"
                className="btn btn-secondary"
                onClick={() => setAlertModal(false)}
              >
                {t("close")}
              </ButtonComponent>
              <ButtonComponent
                type="button"
                className={`btn ${
                  status === "activate" ? "btn-success" : "btn-danger"
                }`}
                onClick={() => ClinicActiveDeactive()}
                disabled={toggleLoading}
              >
                {toggleLoading ? t("loading") || "Loading..." : t("Ok")}
              </ButtonComponent>
            </Modal.Footer>
          </div>
        </Modal>

        <Modal
          show={deleteModel}
          onHide={() => !deleteLoading && setdeleteModel(false)}
        >
          <div className="mc-alert-modal">
            <i className="material-icons">new_releases</i>
            <h3>Are you sure!</h3>
            <p>Want to delete this clinic?</p>
            <Modal.Footer>
              <ButtonComponent
                type="button"
                className="btn btn-secondary"
                onClick={() => setdeleteModel(false)}
              >
                {t("close")}
              </ButtonComponent>
              <ButtonComponent
                type="button"
                className={`btn ${
                  status === "activate" ? "btn-success" : "btn-danger"
                }`}
                onClick={() => deleteClinic()}
                disabled={deleteLoading}
              >
                {deleteLoading ? t("loading") || "Loading..." : t("Ok")}
              </ButtonComponent>
            </Modal.Footer>
          </div>
        </Modal>

        <Modal show={deleteModel1} onHide={() => setdeleteModel1(false)}>
          <div className="mc-alert-modal">
            <i className="material-icons">new_releases</i>
            <h3>{t("success")}</h3>
            <p>{t("clinic_deleted")}</p>
            <Modal.Footer></Modal.Footer>
          </div>
        </Modal>
      </div>
    </>
  );
}
